import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../../common/store/generic.effects';
import { CommissionAction, commissionActions } from './commission.actions';
import { CommissionApiService } from './commission.api.service';
import { searchActions } from '../../search/search.actions';
import { Store } from '@ngrx/store';

@Injectable()
export class CommissionEffects {
  constructor(
    private readonly store: Store<any>,
    private readonly commissionApiService: CommissionApiService,
    private readonly action$: Actions<CommissionAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    commissionActions.getById,
    this.commissionApiService.getById,
  );

  getCommissionsPreview = createApiCallEffects(
    this,
    this.action$,
    commissionActions.getCommissionsPreview,
    this.commissionApiService.getCommissionsPreview,
  );

  add = createApiCallEffects(
    this,
    this.action$,
    commissionActions.add,
    this.commissionApiService.add,
  );

  addSalesPersonCommissionPayment = createApiCallEffects(
    this,
    this.action$,
    commissionActions.addSalesPersonCommissionPayment,
    this.commissionApiService.addSalesPersonCommissionPayment,
    (value) => {
      this.store.dispatch(searchActions.search.refresh());
    },
  );

  deleteSalesPersonCommissions = createApiCallEffects(
    this,
    this.action$,
    commissionActions.deleteSalesPersonCommissions,
    this.commissionApiService.deleteSalesPersonCommissions,
    (value) => {
      this.store.dispatch(searchActions.search.refresh());
    },
  );

  deleteSalesPersonCommissionPayment = createApiCallEffects(
    this,
    this.action$,
    commissionActions.deleteSalesPersonCommissionPayment,
    this.commissionApiService.deleteSalesPersonCommissionPayment,
    (value) => {
      this.store.dispatch(searchActions.search.refresh());
    },
  );

  getCompanyCommissions = createApiCallEffects(
    this,
    this.action$,
    commissionActions.getCompanyCommissions,
    this.commissionApiService.getCompanyCommissions,
  );

  getExcludedTaxAnnualFees = createApiCallEffects(
    this,
    this.action$,
    commissionActions.getExcludedTaxAnnualFees,
    this.commissionApiService.getExcludedTaxAnnualFees,
  );

  getApplicationFeesReport = createApiCallEffects(
    this,
    this.action$,
    commissionActions.getApplicationFeesReport,
    this.commissionApiService.getApplicationFeesReport,
  );

  getSalesPersonProductionDashboardData = createApiCallEffects(
    this,
    this.action$,
    commissionActions.getSalesPersonProductionDashboardData,
    this.commissionApiService.getSalesPersonProductionDashboardData,
  );

  getSalesPersonCommissionsDashboardData = createApiCallEffects(
    this,
    this.action$,
    commissionActions.getSalesPersonCommissionsDashboardData,
    this.commissionApiService.getSalesPersonCommissionsDashboardData,
  );
}
